
import React, { useState, useEffect } from "react";
import { db , cloudfunction } from "../firebase"; // Adjust this according to your Firebase setup
import { collection, getDocs } from "firebase/firestore";
import { Card, Button, TextField, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { muiBbtn } from "./style";
import { httpsCallable } from "firebase/functions";

export default function SendEmails() {
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, "users"));
      const userList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setUsers(userList);
    };
    fetchUsers();
  }, []);

  const handleSelectUser = (uid) => {
    setSelectedUsers((prev) =>
      prev.includes(uid) ? prev.filter((id) => id !== uid) : [...prev, uid]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(users.map((user) => user.uid));
    }
    setSelectAll(!selectAll);
  };

  const sendEmails = async () => {
    if (!subject || !body || selectedUsers.length === 0) {
      alert("Please fill all fields and select at least one user.");
      return;
    }
    
    const selectedEmails = users
      .filter(user => selectedUsers.includes(user.uid))
      .map(user => user.email);

      const emailData = {
        to: selectedEmails,
        subject: subject,
        message: body,
      };

      const sendEmailFunction = httpsCallable(cloudfunction, "SendEmailWithAttachment");

    try {
      setLoading(true);
      await sendEmailFunction(emailData);
      setLoading(false);
      alert("Emails sent successfully!");
      setSelectedUsers([]);
      setSearch("");
      setSubject("");
      setBody("");
    } catch (error) {
      console.error("Error sending emails:", error);
      alert("Failed to send emails.", error);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.displayName.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ width: "100%", padding: 40, backgroundColor: "#212C62" }}>
      <Card style={{ padding: 50, borderRadius: 10 }}>
        <h1 style={{ textAlign: "left", color: "#212C62" }}>
          <b>Send Custom Email</b>
        </h1>
        <TextField
          label="Email Subject"
          fullWidth
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Email Body"
          fullWidth
          multiline
          rows={4}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          margin="normal"
        />
        <Button 
          variant="contained" 
          color="primary" 
          style={{ ...muiBbtn, marginTop: 20 }} 
          onClick={sendEmails}
        >
          {loading? "Sending...": "Send Email"}
        </Button>
        <h5 style={{ marginTop: 30, color: "#212C62" }}>Select Users:</h5>
        <TextField
          label="Search Users"
          fullWidth
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          margin="normal"
        />
        <FormControlLabel
          control={<Checkbox checked={selectAll} onChange={handleSelectAll} />}
          label="Select All"
        />
        <Grid container spacing={2} style={{ marginTop: 10 }}>
          {filteredUsers.map((user) => (
            <Grid item xs={12} sm={6} md={4} key={user.uid}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedUsers.includes(user.uid)}
                    onChange={() => handleSelectUser(user.uid)}
                  />
                }
                label={`${user.displayName} (${user.email})`}
              />
            </Grid>
          ))}
        </Grid>
      </Card>
    </div>
  );
}